import { render, staticRenderFns } from "./crm-settings.vue?vue&type=template&id=cd820382&"
import script from "./crm-settings.vue?vue&type=script&lang=js&"
export * from "./crm-settings.vue?vue&type=script&lang=js&"
import style0 from "./crm-settings.vue?vue&type=style&index=0&id=cd820382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports